import React from 'react';
import { getFormattedDate } from '../../../../helpers/localize';
import { useParams } from 'react-router-dom';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import { TABLE_KEYS } from '../../../../redux_store/reducer/reducers/tableReducer/tableReducer';

const TableActions = (props) => {
  const { accountUuid: paramAccountUuid } = useParams();
  const tableKey = paramAccountUuid ? TABLE_KEYS.botActivitiesDSTable : TABLE_KEYS.botActivitiesTable;

  return props.isPatientPage ? <></> : <>
    <DownloadTableFile
      fileName={`Bot Activity ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-ecw-activities.csv'}
      tableKey={tableKey}
      {...props}
    />
  </>;
};

export default TableActions;
